import { render } from "./flowAudit.vue?vue&type=template&id=f96f5190&scoped=true"
import script from "./flowAudit.vue?vue&type=script&lang=js"
export * from "./flowAudit.vue?vue&type=script&lang=js"

import "./flowAudit.vue?vue&type=style&index=0&id=f96f5190&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96f5190"]])

export default __exports__